var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useLocation } from "@reach/router";
import { CONSTANTS } from "../../qnb/qnb-const";
export function useQueryParamDiscountCode() { var location = useLocation(); var search = location.search; var params = new URLSearchParams(search); var discountCode = {}; var paramList = __spreadArray([], __read(params.keys()), false).filter(function (key) { return key.startsWith(CONSTANTS.DISCOUNT_CODE); }); paramList.forEach(function (k) { var code = params.get(k); if (code) {
    discountCode[k] = code;
} }); return discountCode; }
